import TabButton from './tab-button';

export type { TabButtonProps, TabButtonRef, TabButtonOption, TabButtonValue } from './tab-button';
export default TabButton;
